import { useCookies } from 'react-cookie';
import AuthUtils from '../../utils/auth.utils';

export const STORE_WHERE_LOGGED_IN = 'storeWhereLoggedIn';

const useStoreWhereLoggedIn = () => {
  const [, setCookie, removeCookie] = useCookies();

  const setStore = (store: string) => {
    setCookie(STORE_WHERE_LOGGED_IN, store, AuthUtils.cookieConfig().options);
  };

  const readStore = (): string => {
    return AuthUtils.getCookieByKey(STORE_WHERE_LOGGED_IN).toString() || '';
  };

  const removeStore = () => {
    // Remove this removeItem call after a while. They're being left to remove any info from the previous cross store solution.
    localStorage.removeItem(STORE_WHERE_LOGGED_IN);
    removeCookie(STORE_WHERE_LOGGED_IN, AuthUtils.cookieConfig().options);
  };

  return {
    setStore,
    readStore,
    removeStore,
  };
};

export default useStoreWhereLoggedIn;
